import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Available", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Details", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    elevation: 4,
    class: "rounded-xl ma-2 flex-grow-1",
    style: {"overflow-y":"auto","height":"200px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "green-darken-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  (_ctx.patient)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        small: "",
                        class: "ma-2",
                        color: "light-grey"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-bed")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.patient)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        small: "",
                        class: "ma-2",
                        color: "accent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-bed-empty")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.store.location) + " " + _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }),
              (!_ctx.patient)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    class: "text-right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, {
                        text: "Search Patient",
                        location: "top"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            flat: "",
                            icon: "mdi-account-plus"
                          }, props), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" Admit a Patient ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.patient)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                align: "center",
                class: "mx-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-account")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("h3", null, _toDisplayString(_ctx.patient.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                align: "center",
                class: "mt-4 mx-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_chip, {
                    small: "",
                    class: "mr-1",
                    variant: "outlined",
                    color: "jamzcare"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.patient.gender), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_chip, {
                    small: "",
                    variant: "outlined",
                    color: "jamzcare"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "ml-1 mb-2 primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-cake-variant")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.patient.age) + "yrs ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.patient)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                align: "center",
                class: "mx-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (_ctx.patient)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "jamzcare",
                variant: "tonal",
                class: "mt-4 ml-0 rounded-xl",
                elevation: 1,
                to: "/patient-detail"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}